import nanoid from 'nanoid/generate';
import { alphabet, length } from '../constants/generator-options';
import constants from '../constants/common';

function generateBlockId(base) {
  const suffix = nanoid(alphabet, length);
  return `${constants.BLOCK_ID_PREFIX}-${base}-${suffix}`;
}

export default generateBlockId;
